export interface CompositePillGroupProps {
  emptyStateText: string;
  id: string;
  label: string;
  onRemovePill: (removedPill: string) => void;
  pills: string[];
  viewType: CompositePillGroupViewType;
}

export enum CompositePillGroupViewType {
  display = "display",
  form = "form",
}
